<template>
  <div>
    <div class="moneyinvolved-style" v-if="isMobile">
      <toppage></toppage>
      <div class="moneyinvolved-main">
        <div class="mian-header">
          <div class="header-content">
            <h1>涉币案件司法协助</h1>
            <!-- <img
                src="@/assets/image/mobile/newhomepage/bannerline.png"
                alt=""
              /> -->
            <div class="header-bottom">
              <a
                href="https://graphchain.feishu.cn/share/base/form/shrcnF8LqubEE4TK4l7MmlQwFDd"
                target="_blank"
                >司法协助</a
              >
            </div>
          </div>
        </div>
        <div class="main-flow">
          <h1>司法协助流程</h1>
          <img src="@/assets/image/mobile/moneyinvolved/neirong.png" alt="" />
        </div>
        <div class="main-type">
          <h1>合作案件类型</h1>
          <span class="type-toptitle"
            >利用【图链】系统精准梳理作案团队资金结构以及团队层级关系，快速锁定重点嫌疑人相关地址信息以及嫌疑人团队的大量作案地址。预测作案规模、追踪资金销赃、藏匿情况、统计受害人数量和损失。并在后续链上取证、司法鉴定、涉案资金追回等方面为司法检提供了大量支持帮助。</span
          >
          <h3>合作案例超百起，累计帮助挽回近百亿资产损失</h3>
          <div class="type-img">
<img src="@/assets/image/mobile/moneyinvolved/chuanxiaobanner.png" alt="">
<div class="img-content">
  <h3>传销</h3>
                        <span>锁定项目成员、后台数据渗透、层级关系梳理</span>
</div>
          </div>
          <div class="type-img">
<img src="@/assets/image/mobile/moneyinvolved/wangdubanner.png" alt="">
<div class="img-content">
  <h3>网赌</h3>
                        <span>锁定平台代理、打击支付通道、聚焦资沉</span>
</div>
          </div>
          <div class="type-img">
<img src="@/assets/image/mobile/moneyinvolved/zhapianbanner.png" alt="">
<div class="img-content">
  <h3>诈骗</h3>
                        <span>资金挽损、资金穿透、打击下游洗钱人员</span>
</div>
          </div>
          <div class="type-img">
<img src="@/assets/image/mobile/moneyinvolved/xiqianbanner.png" alt="">
<div class="img-content">
  <h3>洗钱</h3>
                        <span>溯源上游资金、聚焦资沉、打击变现人员</span>
</div>
          </div>
          <div class="type-img">
<img src="@/assets/image/mobile/moneyinvolved/daobibanner.png" alt="">
<div class="img-content">
  <h3>偷盗币</h3>
                        <span>分析作案手法、资金穿透、打击下游洗钱人员</span>
</div>
          </div>
          <div class="type-img">
<img src="@/assets/image/mobile/moneyinvolved/2345.png" alt="">
<div class="img-content">
  <h3>毒品</h3>
                        <span>技战模型、挖掘买卖双方身份、扩线分析</span>
</div>
          </div>
        </div>
        <footerpage></footerpage>
      </div>
      <img class="scroll-button" v-if="showButton"  @click="scrollToTop" src="../../assets/image/newhome/huidaodingbu.png" alt="">

    </div>
    <div class="moneyinvolved-style" v-else>
      <full-page :options="options" ref="fullpage">
        <div class="section moneyinvolved-topheader">
          <div v-show="isshebiheader">
            <div class="moneyinvolved-nav">
              <navbar
                classname="businessintroduce"
                childclassname="moneyinvolved"
              ></navbar>
            </div>
            <div class="section-content">
              <div class="top-title">
                <div class="title-info">
                  <h1>涉币案件司法协助</h1>
                  <img src="@/assets/image/newhome/bannerline.png" alt="" />
                  <div class="judiciary-button animated-element1">
                    <a
                      href="https://graphchain.feishu.cn/share/base/form/shrcnF8LqubEE4TK4l7MmlQwFDd"
                      target="_blank"
                      >司法协助</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section moneyinvolved-top">
          <div v-show="isshebi">
            <div class="section-content">
              <div class="top-title">
                <div class="title-info">
                  <h1>司法协助流程</h1>
                  <img
                    class="animated-element1"
                    src="@/assets/image/newslices/newpage/neirong.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="section moneyinvolved-profession">
          <div
            class="profession-content animated-element1"
            v-show="isprofession"
          >
            <div class="profession-box">
              <div class="profession-main">
                <div class="profession-info element-title">
                  <h1>合作案件类型</h1>
                  <p>
                    利用【图链】系统精准梳理作案团队资金结构以及团队层级关系，快速锁定重点嫌疑人相关地址信息以及嫌疑人团队的大量作案地址。预测作案规模、追踪资金销赃、藏匿情况、统计受害人数量和损失。并在后续链上取证、司法鉴定、涉案资金追回等方面为司法检提供了大量支持帮助。
                  </p>
                </div>
                <div class="profession-title">
                  <span class="title-line"></span>
                  <span class="title-content"
                    >合作案例超百起，累计帮助挽回近百亿资产损失</span
                  >
                  <span class="title-line"></span>
                </div>
                <div class="profession-img">
                  <div class="img-content">
                    <span class="outcontent-info"> 传销 </span>
                    <div class="content-mask">
                      <div class="mask-content">
                        <h3>传销</h3>
                        <span>锁定项目成员、后台数据渗透、层级关系梳理</span>
                      </div>
                    </div>
                  </div>
                  <div class="img-content">
                    <span class="outcontent-info">网赌</span>
                    <div class="content-mask">
                      <div class="mask-content">
                        <h3>网赌</h3>
                        <span>锁定平台代理、打击支付通道、聚焦资沉</span>
                      </div>
                    </div>
                  </div>
                  <div class="img-content">
                    <span class="outcontent-info">诈骗</span>

                    <div class="content-mask">
                      <div class="mask-content">
                        <h3>诈骗</h3>
                        <span>资金挽损、资金穿透、打击下游洗钱人员</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="profession-img1">
                  <div class="img-content">
                    <span class="outcontent-info">洗钱</span>

                    <div class="content-mask">
                      <div class="mask-content">
                        <h3>洗钱</h3>
                        <span>溯源上游资金、聚焦资沉、打击变现人员</span>
                      </div>
                    </div>
                  </div>
                  <div class="img-content">
                    <span class="outcontent-info">偷盗币</span>

                    <div class="content-mask">
                      <div class="mask-content">
                        <h3>偷盗币</h3>
                        <span>分析作案手法、资金穿透、打击下游洗钱人员</span>
                      </div>
                    </div>
                  </div>
                  <div class="img-content">
                    <span class="outcontent-info">毒品</span>

                    <div class="content-mask">
                      <div class="mask-content">
                        <h3>毒品</h3>
                        <span>技战模型、挖掘买卖双方身份、扩线分析</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="profession-bottom">
              <newfooter></newfooter>
            </div>
          </div>
        </div>
      </full-page>
      <div></div>
    </div>
  </div>
</template>
<script>
import navbar from "@/components/navbar.vue";
import newfooter from "@/components/newfooter.vue";
// import countTo  from 'vue-count-to';
// import CountUp from "countup"
import toppage from "@/views/newhome/toppage.vue";
import footerpage from "@/views/newhome/footerpage.vue";
export default {
  components: {
    navbar,
    newfooter,
    toppage,
    footerpage,
    // countTo
  },
  data() {
    return {
      showButton: false,
      scrollThreshold: 400,
      deviceType: this.getDeviceType(),
      isMobile: false,
      isshebiheader: false,
      isshebi: false,
      iscorebusiness1: false,
      iscorebusiness2: false,
      isprofession: false,
      // screenWidth: 0,
      // bannerHeight: 0,
      options: {
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        //是否显示导航，默认为false
        navigation: true,
        afterLoad: this.afterLoad,
        onLeave: this.onLeave,

        //为每个section设置背景色
        // sectionsColor: [
        //     "#41b883",
        //     "#ff5f45",
        //     "#0798ec",
        //     "#fec401",
        //     "#1bcee6",
        //     "#ee1a59",
        //     "#2c3e4f",
        //     "#ba5be9",
        //     "#b4b8ab"
        // ],
      },
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    getDeviceType() {
      return window.innerWidth < 768 ? "手机" : "电脑";
    },
    handleResize() {
      this.deviceType = this.getDeviceType();
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 1199;
    },
    //   onLeave(index, direction){
    //   console.log(index, direction);
    // },
    afterLoad(anchorLink, index) {
      console.log(anchorLink, index);
      console.log("Emitted 'after load' event.");
      //获取body的classname，跟随section滑动刷新
      let a = document.body.className;
      console.log(a);
      //在第几页控制相关逻辑
      if (a !== "fp-scroll-mac fp-viewing-0" || a !== "fp-viewing-0") {
        this.isshebiheader = false;
      }
      if (a !== "fp-scroll-mac fp-viewing-1" || a !== "fp-viewing-1") {
        this.isshebi = false;
      }
      if (a !== "fp-scroll-mac fp-viewing-2" || a !== "fp-viewing-2") {
        this.isprofession = false;
      }
      if (a === "fp-scroll-mac fp-viewing-2" || a === "fp-viewing-2") {
        // console.log(eee);
        this.isprofession = true;
      } else if (a === "fp-scroll-mac fp-viewing-1" || a === "fp-viewing-1") {
        this.isshebi = true;
      } else if (a === "fp-scroll-mac fp-viewing-0" || a === "fp-viewing-0") {
        this.isshebiheader = true;
      }
    },

    next() {
      // 向下滚动一页
      this.$refs.fullpage.api.moveSectionUp();
      // this.$refs.fullpage.goTo(0);
    },
  },
  // created(){     location.reload()},
  mounted() {
    if (this.deviceType != "手机" && !this.isMobile) {
      this.next();
    }
    if(this.isMobile){

window.addEventListener('scroll', () => {
  this.showButton = window.scrollY > this.scrollThreshold;
});
}
    // // 首次加载时,初始化高度
    // this.screenWidth = window.innerWidth;
    // this.bannerHeight = (450 / 1450) * this.screenWidth;
    // // 窗口大小发生改变
    // window.onresize = () => {
    //   this.screenWidth = window.innerWidth;
    //   this.bannerHeight = (450 / 1450) * this.screenWidth;
    // };
  },
  created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener('scroll', () => {});

  },
};
</script>
<style>
.fp-warning,
.fp-watermark {
  display: none !important;
}
</style>

<style lang="scss" scoped>
@import "@/assets/scss/moneyinvolved.scss";
</style>
